import { Injectable } from '@angular/core';
import { HttpService } from '../../core/services/http.service';
import { Params } from './pages/list/models/params.model';
import { Params as ParamsUser } from './pages/detail/tabs/users/models/params.model';

@Injectable({ providedIn: 'root' })
export class PartnersTunaService {


  private listUrl = 'partners/general/list';
  private getUrl = 'partners/general/get';
  private getPartnerMerchantUrl = 'partners/merchants/get-partner';

  private createUrl = 'partners/general/create';
  private updateLocaleUrl = 'partners/general/update-locale';
  private saveAccountUrl = 'partners/general/save-account';
  private getAllUsersUrl = 'partners/general/get-all-user-account';
  private simulatePartnerUrl = 'partners/general/simulate';
  private activateServicePartnerUrl = 'partners/general/activate-service';
  private accountInfo = 'partners/general/account-info';
  private saveFeaturesUrl = 'partners/general/save-features';
  private changeUsePortalMerchantUrl = 'partners/general/change-use-portal-merchant';
  private getWizardUrl = 'partners/general/get-wizard';
  private updateWizardUrl = 'partners/general/update-wizard';
  private activateUrl = 'partners/general/activate';

  private environmentListUrl = 'partners/environment/list';
  private updateAccountEnvironmentUrl = 'partners/environment/update/account';
  private updatePartnerEnvironmentUrl = 'partners/environment/update/partner';

  private validateUrl = 'registration/validate';
  private registrationUrl = 'registration/create';
  private checkPartnerUrl = 'partners/check';
  private getMarketplacePartnersUrl = 'partners/getMarketplaces';

  constructor(private httpService: HttpService) { }

  list(partner: string, account: string, params: Params) {
    return this.httpService.post(this.listUrl, params.createPost(), partner, account);
  }

  get(partner: string, account: string, key) {
    const params = {
      key
    };
    return this.httpService.post(this.getUrl, params, partner, account, false);
  }

  getPartnerMerchant(partner: string, account: string, merchant, key) {
    const params = {
      key
    };
    return this.httpService.postMerchant(this.getPartnerMerchantUrl, params, partner, account, merchant, false);
  }


  create(partner: any, account: any, params) {
    return this.httpService.post(this.createUrl, params, partner, account);
  }

  register(partner: any, account: any, params) {
    return this.httpService.post(this.registrationUrl, params, partner, account, true, false, false, true);
  }

  validate(partner: any, account: any, params) {
    return this.httpService.post(this.validateUrl, params, partner, account, true, false, false, true);
  }

  updateLocale(partner: any, account: any, params) {

    return this.httpService.post(this.updateLocaleUrl, params, partner, account);
  }

  saveAccount(partner: any, account: any, params) {
    return this.httpService.post(this.saveAccountUrl, params, partner, account);

  }

  getAllUsersByAccount(partner: string, account: string, partnerSelected, params?: ParamsUser) {
    var parms = {
      key: partnerSelected,
      ...params?.createPost()
    };
    return this.httpService.post(this.getAllUsersUrl, parms, partner, account, true);
  }

  check(key: string) {
    const params = {
      key
    };

    return this.httpService.post(this.checkPartnerUrl, params, null, null, true, false, false, true);
  }

  simulate(partner: string, account: string, params) {
    return this.httpService.post(this.simulatePartnerUrl, params, partner, account, true);
  }

  active(partner: string, account: string, params) {
    return this.httpService.post(this.activateServicePartnerUrl, params, partner, account, true);
  }

  getAccountInfo(partner: string, account: string) {
    return this.httpService.get(this.accountInfo, partner, account);
  }

  saveFeatures(partner: string, account: string, params) {
    return this.httpService.post(this.saveFeaturesUrl, params, partner, account, true);
  }

  environmentList(partner: string, account: string) {
    return this.httpService.get(this.environmentListUrl, partner, account);
  }

  updatePartnerEnvironment(partner: string, account: string, params) {
    return this.httpService.post(this.updatePartnerEnvironmentUrl, params, partner, account);
  }

  updateAccountEnvironment(partner: string, account: string, params) {
    return this.httpService.post(this.updateAccountEnvironmentUrl, params, partner, account);
  }

  changeUsePortalMerchant(partner: string, account: string, params) {
    return this.httpService.post(this.changeUsePortalMerchantUrl, params, partner, account);
  }

  getWizard(partner: string, account: string, wizardName: string) {
    const params = {
      wizard_name: wizardName
    };

    return this.httpService.post(this.getWizardUrl, params, partner, account);
  }

  updateWizard(partner: string, account: string, wizard) {
    const params = {
      wizard
    };

    return this.httpService.post(this.updateWizardUrl, params, partner, account);
  }

  activate(partner: string, account: string, params) {
    return this.httpService.post(this.activateUrl, params, partner, account);
  }

  getMarketplaces() {
    return this.httpService.get(this.getMarketplacePartnersUrl, null, null, true, true);
  }
}
